import AxiosWeb from "../../axios";

const API_AUTH_URL = process.env.REACT_APP_API_AUTH_URL;

const authUser = async (data, encrypt = false) => {
  const response = await AxiosWeb.post(API_AUTH_URL + 'auth/login', data, {
    encrypt: encrypt // This tells axios interceptor to encrypt
  });
  return response?.data;
};

const authMfa = async (data, encrypt = false) => {
  const response = await AxiosWeb.post(API_AUTH_URL + 'auth/mfa-verify', data, {
    encrypt: encrypt // This tells axios interceptor to encrypt
  });
  return response?.data;
};

const authService = {
  authUser,
  authMfa
};

export default authService;